<template>
  <div v-if="delVisible" class="del-wrap">
    <div class="del-text">
      <p>确定删除吗？</p>
      <p>删除后该客户名下合作信息无法恢复</p>
    </div>

    <div class="del-btn">
      <div class="del-btn__cancel" @click="delVisible = false">取消</div>
      <div class="del-btn__confirm" @click="onsubmit()">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wan-del",

  data() {
    return {
      delVisible: false,
      delInfo: {
        url: "",
        data: {},
      },
    };
  },

  methods: {
    async onsubmit() {
      let {
        url,
        data,
        event = "getCustomList",
        args = { v: "getCustomerList" },
      } = this.delInfo;
      if (!url || !data || !Object.keys(data).length) return;
      this.$emit("del", { url, data, event, args });
    },
  },
};
</script>

<style lang="less" scoped>
.del-wrap {
  width: 100%;
  height: 120px;
  background: #ff6600;
  opacity: 1;
  padding: 30px 50px 26px 54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 80px;
  z-index: 9999;

  .del-text {
    p {
      font-size: 16px;
      color: #fff;
    }

    p:first-child {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 12px;
    }
  }

  .del-btn {
    .del-btn__cancel,
    .del-btn__confirm {
      width: 100px;
      height: 50px;
      opacity: 1;
      line-height: 50px;
      text-align: center;
      color: #f1f5f8;
      border-radius: 4px;
      float: left;
      background: #333;
    }

    .del-btn__confirm {
      background: #fff;
      color: #333333;
      margin-left: 20px;
    }
  }
}
</style>
